import { render } from "./ManagerGroupUserView.vue?vue&type=template&id=135913b0"
import script from "./ManagerGroupUserView.vue?vue&type=script&lang=js"
export * from "./ManagerGroupUserView.vue?vue&type=script&lang=js"

import "./ManagerGroupUserView.vue?vue&type=style&index=0&id=135913b0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__